<header class="delete-form__header">
  {{ strategy.title | translate }}
</header>

<section class="delete-form__body">
  <p class="delete-form__subtitle" [innerHTML]="strategy.subtitle | translate"></p>

  <div class="delete-form__actions">
    <button
      hlmBtn
      type="button"
      variant="destructive"
      class="delete-form__delete-button"
      [disabled]="isDeleting()"
      (click)="onDelete()"
    >
      {{ strategy.deleteButtonLabel | translate }}
    </button>

    <button
      hlmBtn
      type="button"
      variant="secondary"
      class="delete-form__cancel-button"
      [disabled]="isDeleting()"
      (click)="onCancel()"
    >
      <ocp-themed-icon name="cross.svg" />
      {{ strategy.cancelButtonLabel | translate }}
    </button>
  </div>
</section>
